import React from 'react';

import { cn } from '@lyearn/style';
import { StatusPill, TimelineDot } from '@lyearn/ui';
import { ResourceVersionTypeEnum } from '@/types/schema';

interface TimeLineDotProps {
  versionNumber: string;
  type: ResourceVersionTypeEnum;
  isFirstItem: boolean;
}

const DOT_CLASSNAME =
  'flex items-center justify-center border-0 shadow-none p-0 m-0 mt-16 z-10 !bg-transparent';
const TIMELINE_DOT_SIZE = 'h-24 w-[66px]';

const VersionTimelineDot = ({ versionNumber, isFirstItem, type }: TimeLineDotProps) => (
  <TimelineDot className={cn(DOT_CLASSNAME, TIMELINE_DOT_SIZE)}>
    <StatusPill
      appearance="secondary"
      className={cn(isFirstItem ? '!bg-focus-primary' : '')}
      label={`v${versionNumber}`}
      size="medium"
      variant={`${
        isFirstItem ? 'filled' : type === ResourceVersionTypeEnum.Minor ? 'outlined' : 'light'
      }`}
    />
  </TimelineDot>
);

export default VersionTimelineDot;
